export default {
      id: "arrow-right-usage",
      viewBox: "3 -1 40 16",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#arrow-right",
      toString: function () {
        return this.url;
      }
    }